export default __webpack_public_path__ + "static/media/speaker-sound-box-pngrepo-com.4ae7dc6a.png";